import { isObject } from '@helpers';
import moment from 'moment';

const getNestedValue = (obj, path) => path.split('.').reduce((acc, key) => acc?.[key], obj);
export const filterQueryResults = (data, filterColumns, debouncedSearchQuery) => {
  if (!debouncedSearchQuery) return data;
  return data.filter((item) =>
    filterColumns.some((name) => {
      let value = getNestedValue(item, name); // Supports dot walking
      if (isObject(value)) {
        value = value['searchName'] ?? value['name'];
      }
      return (
        value != null && String(value).toLowerCase().includes(debouncedSearchQuery.toLowerCase())
      );
    })
  );
};

export const getTableFilterResults = (data, filters) => {
  let results = [...data];
  Object.keys(filters).forEach((key) => {
    if (Array.isArray(filters[key]) && filters[key].length) {
      results = results.filter((item) => {
        let value = getNestedValue(item, key);
        if (isObject(value)) {
          value = value['name'];
        }
        return filters[key].includes(value);
      });
    } else if (typeof filters[key] === 'object' && 'min' in filters[key]) {
      results = results.filter((item) => {
        const value = getNestedValue(item, key);
        return (
          (filters[key].min === null || filters[key].min <= value) &&
          (filters[key].max === null || filters[key].max >= value)
        );
      });
    } else if (isObject(filters[key]) && 'startDate' in filters[key]) {
      const hasStart = !!filters[key].startDate && filters[key].startDate.isValid();
      const hasEnd = !!filters[key].endDate && filters[key].endDate.isValid();
      if (!hasStart && !hasEnd) return;
      results = results.filter((item) => {
        let valid = true;
        const value = getNestedValue(item, key);
        if (!value) {
          valid = false;
        }
        if (hasStart && moment.utc(value).isBefore(filters[key].startDate)) {
          valid = false;
        }
        if (hasEnd && moment.utc(value).isAfter(filters[key].endDate)) {
          valid = false;
        }
        return valid;
      });
    } else if (typeof filters[key] === 'string' && filters[key] !== '') {
      results = results.filter((item) => {
        let value = getNestedValue(item, key);
        if (isObject(value)) {
          value = value['name'] ?? '';
        }
        return `${value}`.toLowerCase().includes(filters[key].toLowerCase());
      });
    }
  });
  return results;
};

export const getDefaultTableFilters = (columns) => {
  let tempFilters = {};
  columns.forEach(({ options, name }) => {
    if (options.customFilterType === 'multiselect') tempFilters[name] = [];
    if (options.customFilterType === 'textField') tempFilters[name] = '';
    if (options.customFilterType === 'minMax') tempFilters[name] = { min: null, max: null };
    if (options.customFilterType === 'dateBetween')
      tempFilters[name] = { startDate: null, endDate: null };
  });
  return tempFilters;
};

export const getFilterCount = (tableFilters) => {
  return Object.values(tableFilters).reduce((count, filter) => {
    if (Array.isArray(filter)) {
      return filter.length > 0 ? count + 1 : count;
    }
    if (typeof filter === 'string' && filter.length) return count + 1;
    if (typeof filter === 'object') {
      if ('min' in filter && (filter.min !== null || filter.max !== null)) {
        return count + 1;
      }
      if ('startDate' in filter && (filter.startDate !== null || filter.endDate !== null)) {
        return count + 1;
      }
    }
    return count;
  }, 0);
};
